import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  GetRoutineCareRequest,
  GetRoutineCareResponse,
  RoutineCare,
  SaveRoutineCareRequest,
  SaveRoutineCareResponse,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class RoutineCareService {
  private readonly baseUrl = `${environment.api.baseUrl}/benefit-services/v1/routine-cares`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetRoutineCareRequest): Promise<GetRoutineCareResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.status) httpParams = httpParams.set('status', params.status)

      const hasStart = !!params.startModifiedDate
      const hasEnd = !!params.endModifiedDate

      if (hasStart && hasEnd) {
        httpParams = httpParams
          .set('startModifiedDate', params.startModifiedDate!)
          .set('endModifiedDate', params.endModifiedDate!)
      }
    }

    const response = await firstValueFrom(this.http.get<GetRoutineCareResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<RoutineCare> {
    const response = await firstValueFrom(this.http.get<RoutineCare>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveRoutineCareRequest): Promise<SaveRoutineCareResponse> {
    const response = await firstValueFrom(this.http.post<SaveRoutineCareResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveRoutineCareRequest): Promise<SaveRoutineCareResponse> {
    const response = await firstValueFrom(this.http.put<SaveRoutineCareResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
